export const documentStateLabels = {
  UNREAD: "Not read yet",
  PROCESSING: "Reading documents",
  PARTIAL: "Partially read",
  READY: "Evidence ready",
  ACCESS_REQUIRED: "Authorized access required",
  FAILED: "Document processing failed",
};

export const ppaDocumentPresentation = (data) => ({
  state: documentStateLabels[data?.state] || "Document status unavailable",
  ready: data?.state === "READY",
  blocked: ["ACCESS_REQUIRED", "FAILED"].includes(data?.state),
  processing: ["UNREAD", "PROCESSING", "PARTIAL"].includes(data?.state),
  scopeSummary: data?.scopeSummary || "No evidence-backed scope is available yet.",
  counts: data?.documents || { discovered: 0, acquired: 0, read: 0, controlled: 0, failed: 0 },
  missingDocuments: Array.isArray(data?.missingDocuments) ? data.missingDocuments : [],
  humanActions: Array.isArray(data?.humanActions) ? data.humanActions : [],
  criticalDates: Array.isArray(data?.criticalDates) ? data.criticalDates : [],
  requirements: Array.isArray(data?.complianceRequirements) ? data.complianceRequirements : [],
  risks: Array.isArray(data?.keyRisks) ? data.keyRisks : [],
});
